/**
 * IDs of `AppBarMenu` components (src/components/AppBar/AppBarMenu/).
 */
export const appBarMenuElementIDs = {
  darkModeSwitch: "appbar-menu__dark-mode-switch",
  desktopUserAvatarMenuButton: "appbar-menu__desktop-user-avatar-menu-button",
  desktopMenuRoot: "appbar-menu__desktop-menu-root",
} as const;
